// Official WMO weather interpretation codes, as used by Open-Meteo's
// `weather_code` field (https://open-meteo.com/en/docs) - French labels
// translated directly from the WMO code meanings, not invented. Codes 95/96/99
// are the only thunderstorm codes; the UI shows them as "Orage" (from the
// WMO meaning "Thunderstorm"), never phrased as "lightning detected".
const WMO_CODES = {
  0: { label: 'Ciel dégagé', icon: '☀️' },
  1: { label: 'Principalement dégagé', icon: '🌤️' },
  2: { label: 'Partiellement nuageux', icon: '⛅' },
  3: { label: 'Couvert', icon: '☁️' },
  45: { label: 'Brouillard', icon: '🌫️' },
  48: { label: 'Brouillard givrant', icon: '🌫️' },
  51: { label: 'Bruine légère', icon: '🌦️' },
  53: { label: 'Bruine modérée', icon: '🌦️' },
  55: { label: 'Bruine dense', icon: '🌦️' },
  56: { label: 'Bruine verglaçante légère', icon: '🌧️' },
  57: { label: 'Bruine verglaçante dense', icon: '🌧️' },
  61: { label: 'Pluie légère', icon: '🌧️' },
  63: { label: 'Pluie modérée', icon: '🌧️' },
  65: { label: 'Pluie forte', icon: '🌧️' },
  66: { label: 'Pluie verglaçante légère', icon: '🌧️' },
  67: { label: 'Pluie verglaçante forte', icon: '🌧️' },
  71: { label: 'Neige légère', icon: '🌨️' },
  73: { label: 'Neige modérée', icon: '🌨️' },
  75: { label: 'Neige forte', icon: '🌨️' },
  77: { label: 'Grains de neige', icon: '🌨️' },
  80: { label: 'Averses de pluie légères', icon: '🌦️' },
  81: { label: 'Averses de pluie modérées', icon: '🌦️' },
  82: { label: 'Averses de pluie violentes', icon: '⛈️' },
  85: { label: 'Averses de neige légères', icon: '🌨️' },
  86: { label: 'Averses de neige fortes', icon: '🌨️' },
  95: { label: 'Orage', icon: '⛈️' },
  96: { label: 'Orage avec grêle légère', icon: '⛈️' },
  99: { label: 'Orage avec grêle forte', icon: '⛈️' }
};

export function wmoLabel(code) {
  return WMO_CODES[code]?.label || `Code météo ${code}`;
}

export function wmoIcon(code) {
  return WMO_CODES[code]?.icon || '❓';
}

export function isThunderstormCode(code) {
  return code === 95 || code === 96 || code === 99;
}
